import { render, staticRenderFns } from "./OrigenPage.vue?vue&type=template&id=6c4d4a52"
import script from "./OrigenPage.js?vue&type=script&lang=js&external"
export * from "./OrigenPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports